"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("../colors");
var Birch = {
  borderColor: _colors.FullPalette.GREY_700,
  buttonPadding: '0.5rem 1.5rem',
  checkboxSpacing: 2,
  containerPadding: '1rem',
  expandableMenuPadding: '1rem',
  iconSizeSmall: '1.25rem',
  iconSizeMedium: '1.5rem',
  fontMediumSize: '1rem',
  fontMediumLineHeight: '1.5rem',
  fontSmallSize: '.875rem',
  fontSmallLineHeight: '1.25rem',
  radioSize: '1.125rem',
  radioSpacing: 2,
  radioOffset: '4px',
  tableRowPadding: '1rem',
  toggleHeight: '1.375rem',
  toggleWidth: '2.75rem',
  toggleCircleSize: '1rem',
  toggleCircleTop: '0.185rem',
  toggleCircleTranslateX: '1.25em',
  toggleXIconTop: '0.0625rem',
  tooltipPadding: '1rem',
  typographyLegendSize: '0.8125rem'
};
var Dense = {
  borderColor: _colors.FullPalette.GREY_700,
  buttonPadding: '0.4375rem 1rem',
  checkboxSpacing: 1,
  containerPadding: '1rem',
  expandableMenuPadding: '.75rem',
  iconSizeSmall: '1rem',
  iconSizeMedium: '1.25rem',
  fontMediumSize: '.875rem',
  fontMediumLineHeight: '1.25rem',
  fontSmallSize: '.75rem',
  fontSmallLineHeight: '1.125rem',
  radioSize: '1rem',
  radioSpacing: 1,
  radioOffset: '3px',
  tableRowPadding: '.75rem',
  toggleHeight: '1.2rem',
  toggleWidth: '2.4rem',
  toggleCircleSize: '.85rem',
  toggleCircleTop: '0.175rem',
  toggleCircleTranslateX: '1.2em',
  toggleXIconTop: '.1rem',
  tooltipPadding: '1rem',
  typographyLegendSize: '0.8125rem'
};
var ThemeNameToObject = {
  birch: Birch,
  dense: Dense
};
var getTheme = function getTheme(themeKey) {
  return themeKey in ThemeNameToObject ? ThemeNameToObject[themeKey] : Birch;
};
var _default = exports["default"] = getTheme;